// ─── PLAN CATALOG ────────────────────────────────────────────────────────────
// Αυτό είναι το ΜΟΝΑΔΙΚΟ σημείο αλλαγής για τιμές, περιγραφές και όρια πλάνων.
// Και το LandingPage και το OrganizationSettings διαβάζουν από εδώ.
// Για τα όρια enforcement στο backend, ενημέρωσε και το backend/src/organizations/plan-limits.ts

export interface PlanConfig {
  id: string;
  name: string;
  price: string;          // Εμφανίζεται ως "€XX/μήνα"
  priceNumber: string;    // Μόνο ο αριθμός για το LandingPage (π.χ. "49")
  desc: string;           // Σύντομη περιγραφή
  features: string[];     // Λίστα χαρακτηριστικών
  highlighted: boolean;   // Αν εμφανίζεται highlighted στο landing page
  maxProjects: number | null;  // null = απεριόριστο
  maxUsers: number | null;     // null = απεριόριστο
}

export const PLAN_CATALOG: PlanConfig[] = [
  {
    id: 'starter',
    name: 'Starter',
    price: '€19/μήνα',
    priceNumber: '19',
    desc: 'Για μικρές ομάδες και μεμονωμένους PM',
    features: [
      'Έως 3 ενεργά έργα',
      'Έως 10 χρήστες',
      'AI Advisor',
      'BYO AI Key',
      'Email support',
    ],
    highlighted: false,
    maxProjects: 3,
    maxUsers: 10,
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '€29/μήνα',
    priceNumber: '29',
    desc: 'Για αναπτυσσόμενες εταιρείες',
    features: [
      'Έως 10 ενεργά έργα',
      'Έως 20 χρήστες',
      'AI ανάλυση + Advisor',
      'BYO AI Key',
      'Priority support',
    ],
    highlighted: true,
    maxProjects: 10,
    maxUsers: 20,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: '€199/μήνα',
    priceNumber: '199',
    desc: 'Για οργανισμούς με πολλά έργα',
    features: [
      'Απεριόριστα έργα',
      'Έως 50 χρήστες',
      'Όλες οι AI λειτουργίες',
      'Dedicated support',
      'Custom onboarding',
    ],
    highlighted: false,
    maxProjects: null,
    maxUsers: 50,
  },
];
